import React, { useState } from "react";
import Layout from "../Layout/Layout";
import GetSvgIcon from "../../images/svglist";
import { BLACK_SPCL_CHARS, REQUIRED_ERR_MSG } from "../Helper/Constants";
import { useForm } from "react-hook-form";
import { CallApiGet } from "../Helper/serviceApi";
import InvoiceDetailsLists from "./InvoiceDetailsLists";
import { StyleComponent } from "../Utilities/Styles";
import { LINEHAUL_CUSTOMER_BUSINESS_PARTNERS } from "../../ConfigConstants/ConfigConstants";

const initAlertConfig = {
  isSuccess: false,
  size: "",
  show: false,
  title: "",
  description: "",
};
const FindInvoiceDetails = () => {
  const [spinner, setSpinner] = useState(false);
  const [alertConfig, setAlertConfig] = useState(initAlertConfig);
  const [invData, setInvData] = useState([]);
  const {
    register,
    watch,
    formState: { errors, isDirty },
  } = useForm();
  const watchInv = watch("invoice");
  const hideAlert = () => {
    setAlertConfig({
      isSuccess: false,
      size: "",
      show: false,
      title: "",
      description: "",
    });
  };

  const loadInvoiceData = async (invNo) => {
    setSpinner(true);
    // const invNoStr = invNo.join(",");
    const invNoStr = invNo
      .split(",")
      .map((inv) => inv.trim())
      .filter((inv) => inv);
    const uri = `getInvDetails?invoiceNos=${invNoStr}`;

    let resp = await CallApiGet(uri);
    if (resp.respCode === 200) {
      if (resp.respData.length > 0) setInvData(resp.respData);
      else setInvData([]);
    } else {
      setInvData([]);
      console.error(resp.respMessage);
    }
    setSpinner(false);
  };
  const invoiceDownload = async (orderData) => {
    setSpinner(true);
    //== This customer type is made false intentionally
    //== Invoice template of International Inbound Order is always of Personal Customer type
    let custType = LINEHAUL_CUSTOMER_BUSINESS_PARTNERS.includes(
      String(orderData.cust_type)
    )
      ? true
      : false;
    if (
      orderData.invoiceNo.includes("-II-") ||
      orderData.invoiceNo.includes("DN")
    ) {
      custType = false;
    }
    const response = await CallApiGet(
      `generateAllInvoicePdf/${orderData.invoiceNo}/${custType}`
    );
    setSpinner(false);
    if (response.respCode === 200) {
      window.open(response.respData, "_blank");
    }
  };
  return (
    <Layout
      spinnershow={spinner}
      alertConfig={alertConfig}
      hideAlert={hideAlert}
    >
      <div className="clearfix border-bottom">
        <div className="float-start">
          <div className="section-title mt-1">Invoice Explorer</div>
        </div>
      </div>
      <>
        <div className="w-50 m-auto">
          <div className="input-group my-3">
            <input
              type="text"
              className="form-control"
              style={StyleComponent.searchCapsule}
              placeholder="Enter invoice numbers separated by comma"
              {...register("invoice", {
                pattern: {
                  validate: (v) => (BLACK_SPCL_CHARS.test(v) ? false : true),
                },
                required: {
                  value: true,
                  message: REQUIRED_ERR_MSG,
                },
              })}
            />
            <button
              className="btn btn-outline-secondary theme-violet rounded-1s input-group-text"
              type="button"
              id="button-addon2"
              title="Track"
              onClick={() => loadInvoiceData(watch("invoice"))}
              disabled={!watchInv}
            >
              Search Invoice {GetSvgIcon("ArrowRight")}
            </button>
          </div>
        </div>
      </>
      {invData.length > 0 && (
        <InvoiceDetailsLists
          invDetails={invData}
          invoiceDownload={invoiceDownload}
        />
      )}
    </Layout>
  );
};

export default FindInvoiceDetails;
